import _createClass from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _possibleConstructorReturn from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @import {Space} from 'property-information'
 */

import { Info } from './info.js';
import * as types from './types.js';
var checks = /** @type {ReadonlyArray<keyof typeof types>} */
Object.keys(types);
export var DefinedInfo = /*#__PURE__*/function (_Info) {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  function DefinedInfo(property, attribute, mask, space) {
    var _this;
    _classCallCheck(this, DefinedInfo);
    var index = -1;
    _this = _callSuper(this, DefinedInfo, [property, attribute]);
    mark(_this, 'space', space);
    if (typeof mask === 'number') {
      while (++index < checks.length) {
        var check = checks[index];
        mark(_this, checks[index], (mask & types[check]) === types[check]);
      }
    }
    return _this;
  }
  _inherits(DefinedInfo, _Info);
  return _createClass(DefinedInfo);
}(Info);
DefinedInfo.prototype.defined = true;

/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}